import { AllHTMLAttributes, FC } from 'react';

import S from './Input.styled';

interface IInputProps extends AllHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input: FC<IInputProps> = ({ error, ...props }) => {
  return (
    <S.Wrapper>
      <S.Input {...props} />
      {error && <p className="inputError">{error}</p>}
    </S.Wrapper>
  );
};
